import LengthValidator from '../../Components/Form/Validators/Length';

const ALREADY_REGISTERED = 'User Already Exists';

export const PasswordLengthValidator = LengthValidator(8, null, 'Your password needs at least 8 characters.');

export const isAlreadyRegistered = (err) => err?.[0]?.code === 400 && err[0].title === ALREADY_REGISTERED;

export const registerFailureReason = (err) => {
    const error = Array.isArray(err) ? err[0] : null;

    if (!error) {
        return 'unknown';
    }

    if (error.code === 0) {
        return 'network';
    }

    if (error.field) {
        return `invalid:${error.field}`;
    }

    return String(error.title ?? error.code).slice(0, 100);
};
